module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cR9YV"))).then(() => parcelRequire('ikE14'));